import { useState } from 'react';
import { usePwaInstall } from '../hooks/usePwaInstall.js';

export function InstallAppButton({ className = '' }) {
  const { showInstall, canPrompt, installed, install, dismiss, hint } = usePwaInstall();
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');

  if (installed || !showInstall) return null;

  const handleInstall = async () => {
    if (!canPrompt) {
      setMessage(hint);
      return;
    }
    setBusy(true);
    setMessage('');
    try {
      const result = await install();
      if (!result.ok && result.reason === 'dismissed') {
        setMessage('Instalação cancelada.');
      }
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className={`install-app ${className}`.trim()}>
      <button
        type="button"
        className="install-app__btn"
        onClick={() => void handleInstall()}
        disabled={busy}
        title={hint}
      >
        {busy ? '…' : '📲 Instalar app'}
      </button>
      <button type="button" className="install-app__close" onClick={dismiss} aria-label="Fechar">
        ×
      </button>
      {message ? <p className="install-app__hint">{message}</p> : null}
    </div>
  );
}
